import { useEffect, useState } from 'react';

type UnlockStatus = 'idle' | 'checking' | 'success' | 'fail';

export function useMagicLinkUnlock(): UnlockStatus {
  const [status, setStatus] = useState<UnlockStatus>('idle');

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) return;

    setStatus('checking');

    fetch('/.netlify/functions/verifyMagicLink', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })
      .then((res) => res.json())
      .then(({ unlocked, email }) => {
        if (unlocked) {
          localStorage.setItem('kofiUnlockValidated', 'true');
          localStorage.setItem('kofiEmail', email);
          setStatus('success');
        } else {
          setStatus('fail');
        }
      })
      .catch(() => setStatus('fail'))
      .finally(() => {
        const url = new URL(window.location.href);
        url.searchParams.delete('code');
        if (url.pathname === '/unlock') {
          url.pathname = '/';
        }
        window.history.replaceState({}, document.title, url.toString());
      });
  }, []);

  return status;
}
